import { render } from "./CopyableTextSummary.vue?vue&type=template&id=03aa2282&ts=true"
import script from "./CopyableTextSummary.vue?vue&type=script&lang=ts"
export * from "./CopyableTextSummary.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__